import React from 'react';
import { FontFamilyOptionList } from './FontFamilyOptionList';
import { DropdownMenu } from '@gift/ui/components/dropdown/partials/DropdownMenu';

export const FontFamilyDropdownMenu = ({
    toggle, commit,
    selectedFontFamily,
}: Props) => (
    <DropdownMenu onClick={toggle}>
        <FontFamilyOptionList selectedFontFamily={selectedFontFamily} onClick={commit} />
    </DropdownMenu>
);

type Props = {
    selectedFontFamily: string,
    toggle: () => void,
    commit: (fontFamily: string) => void
};
